import { createSelector } from '@ngrx/store';
import { getDragonflySharedState } from '../reducers';

export const getEnvironmentState = createSelector(
  getDragonflySharedState,
  (state) => state.environment,
);

export const getProductionStatus = createSelector(getEnvironmentState, ({ isProd }) => isProd);

export const getAccount = createSelector(getEnvironmentState, ({ account }) => account);
